export default "__VITE_ASSET__CifNGC6___"